module.exports = __webpack_public_path__ + "img/shopping_basket_icon.c8cf93db.svg";